export default __webpack_public_path__ + "static/media/BuckeyeSmooth-Scarlet.d7835b70.svg";